import React, { useMemo, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Text } from '../../../../../common';
import { AppMenu, Img } from '../../../../common';
import { Authorization } from '../../../../authorization';
import { Profile, useUser } from '../../../../user';
import { useMenu } from '../../../../common';
import useGTM, { Events } from '../../../../../common/hooks/useGTM';

import userLoginWhite from '../../../../../assets/icons/user-login-white.svg';
import userProfileWhite from '../../../../../assets/icons/profile-user-white.svg';

import './styles.less';

const UserAction = props => {
  const { hideText } = props;
  const { t } = useTranslation();
  const { menuOpened, triggerMenu } = useMenu();
  const { userState } = useUser();
  const { user } = userState;
  const { pushEvent } = useGTM();

  const isLoginOpened = useMemo(
    () => menuOpened === 'login',
    [menuOpened]
  );

  const isProfileOpened = useMemo(
    () => menuOpened === 'profile',
    [menuOpened]
  );

  useEffect(() => {
    if (user && isLoginOpened) {
      triggerMenu();
    }
  // eslint-disable-next-line
  }, [isLoginOpened, user]);

  useEffect(() => {
    if (!user && isProfileOpened) {
      triggerMenu();
    }
  // eslint-disable-next-line
  }, [isProfileOpened, user]);

  const handleOnLoginClick = useCallback(
    () => {
      triggerMenu('login');
      pushEvent(Events.landingCategory.loginClickEvent());
    },
    [pushEvent, triggerMenu]
  );

  const handleOnProfileClick = useCallback(
    () => {
      triggerMenu('profile');
      pushEvent(Events.landingCategory.profileClickEvent());
    },
    [pushEvent, triggerMenu]
  );

  return useMemo(() => {
    return (
      <>
        {!user && (
          <button
            className="action-item-wrapper"
            onClick={handleOnLoginClick}
          >
            <Img
              src={userLoginWhite}
              alt="user login white"
            />
            {!hideText && <Text white h5 upper style={{ marginTop: 5 }}>{t`Login`}</Text>}
          </button>
        )}
        {user && (
          <button
            className="action-item-wrapper"
            onClick={handleOnProfileClick}
          >
            <Img
              src={userProfileWhite}
              alt="user login white"
            />
            {!hideText && <Text white h5 upper style={{ marginTop: 5 }}>{t`Profile`}</Text>}
          </button>
        )}
        {isLoginOpened && (
          <AppMenu>
            <Authorization />
          </AppMenu>
        )}
        {(isProfileOpened && user) && (
          <AppMenu>
            <Profile />
          </AppMenu>
        )}
      </>
    );
  }, [
    user,
    handleOnLoginClick,
    hideText,
    t,
    handleOnProfileClick,
    isLoginOpened,
    isProfileOpened
  ]);
};

UserAction.propTypes = {
  hideText: PropTypes.bool
};

export default UserAction;